import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import NotesListing from '@cont/Store/Notes/NotesListing';
import Layout from '@layout/index';
import {
  fetchPostSubNotesDetails,
  fetchPreSubNotesDetails
} from '@api/fetchers/store';
import { fetchSubscriptionFaqs } from '@api/fetchers/checkout';
import { BLOCK_TYPE } from '@cont/Store/Notes/constants';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsUserSubscribedToStoreBundle } from '@api/selectors/subscription';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const Notes = ({ fallbackData }) => {
  const { notesData, faqBlock } = fallbackData;
  const [data, setData] = useState([...notesData, faqBlock]);

  const {
    query: { noteUID }
  } = useRouter();

  const hasActiveNotesSubscription = useMyInfo(
    getIsUserSubscribedToStoreBundle(noteUID, '600')
  );
  const { refetchMyInfo } = useMyInfo();

  useEffect(() => {
    refetchMyInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (hasActiveNotesSubscription) {
      fetchPostSubNotesDetails(noteUID).then((res) => {
        setData([...res.slice(1), res[0], faqBlock]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasActiveNotesSubscription, noteUID]);

  return <NotesListing data={data} />;
};

export const getStaticProps = async ({ params: query }) => {
  try {
    const notesData = await fetchPreSubNotesDetails(query.noteUID);
    let faqsData = [];

    if (notesData.error) {
      return { notFound: true, revalidate: 60 };
    }

    const isDigitalNotesPresent = notesData.some(
      (block) => block.blockType === BLOCK_TYPE.DIGITAL
    );
    const isPhysicalNotesPresent = notesData.some(
      (block) => block.blockType === BLOCK_TYPE.PHYSICAL
    );

    if (isDigitalNotesPresent && !isPhysicalNotesPresent) {
      faqsData = await fetchSubscriptionFaqs('digitalnotes');
    } else if (!isDigitalNotesPresent && isPhysicalNotesPresent) {
      faqsData = await fetchSubscriptionFaqs('physicalnotes');
    } else {
      faqsData = await fetchSubscriptionFaqs('notesCombo');
    }

    const faqBlock = {
      blockType: 'faqs',
      blockData: faqsData.faqs
    };

    return {
      props: {
        fallbackData: {
          notesData,
          faqBlock
        }
      },
      revalidate: 5 * 60
    };
  } catch {
    return { notFound: true, revalidate: 60 };
  }
};

Notes.pageInfo = {
  name: 'Notes',
  isMWebSupported: true,
  layoutOptions: {
    useLightBaseColor: true
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

export default Notes;

Notes.Layout = Layout;
Notes.Wrapper = PageReduxProvider;
